import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { useNavigate } from "react-router-dom";

import { FaCopy, FaCheck } from "react-icons/fa";
import { NFTContarct,NFTDataContract } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import Nodata from "../assets/img/no-record-found.png";
import NFTDataContractABI from "../abis/NFTDataContractABI.json";

import Loader from "../components/Loader";
const checkaddress="0xAA0219Eaa1902eB87Aa167600105c5C23e6D7468";
const MyNFTDetails = () => {
  const navigate = useNavigate();  // ⭐ Added

  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [isLoading, setIsLoading] = useState(true);
  const [web3, setWeb3] = useState(null);
  const [nftList, setNftList] = useState([]);
  const [activeTab, setActiveTab] = useState("TradeHistory");
  const [nowTime, setNowTime] = useState(Math.floor(Date.now() / 1000));

  const [tokenId, setTokenId] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

    // ✅ PAGINATION STATES
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 8;

  const formatBalance = (balance) => {
    const num = Number(balance);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  // const targetaddress="0x5FD893dF1A7c03f1F673Aa164632A7282Ddd8989";

  useEffect(() => {
  const timer = setInterval(() => {
    setNowTime(Math.floor(Date.now() / 1000));
  }, 1000);

  return () => clearInterval(timer);
}, []);


 const getRemainingTime = (onSaleTimeStamp) => {
  let diff = Number(onSaleTimeStamp) - nowTime;

  if (diff <= 0) return null; // ⛔ time khatam → timer band

  const hours = Math.floor(diff / 3600);
  diff = diff % 3600;

  const minutes = Math.floor(diff / 60);
  const seconds = diff % 60;

  return `${hours}h ${minutes}m ${seconds}s`;
};



const getSaleStatus = (onSaleTimeStamp) => {
  return nowTime >= Number(onSaleTimeStamp)
    ? "Listed for Market"
    : null;
};



  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "All NFTs") {
      navigate("/nft-market-place");
    } else if (tab === "NFT Activity") {
      navigate("/nft-trade-history");    // ⭐ FIXED
    }
  };
  // INIT WEB3
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;
      if (client?.transport) provider = client.transport;
      else if (window.ethereum) provider = window.ethereum;

      if (!provider) return;

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  // FETCH PORTFOLIO
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchNFTPortfolio();
    }
  }, [address, isConnected, web3]);

  // ---------------- BURN HANDLER ----------------
  const handleBurnNFT = async () => {
    if (!isConnected) {
      alert("Please connect wallet");
      return;
    }

    if (!tokenId || Number(tokenId) <= 0) {
      alert("Enter valid NFT ID");
      return;
    }

    try {
      setLoading(true);
      setMsg("");

      const contract = new web3.eth.Contract(
        NFTABI,
        NFTContarct
      );

      await contract.methods
        .burnMyNFT(tokenId)
        .send({ from: address });

      setMsg(" NFT burned successfully!");
      setTokenId("");
    } catch (err) {
      console.error(err);
      setMsg(
        err?.message ||
          "Transaction failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchNFTPortfolio = async () => {

    try {
      setIsLoading(true);
      console.log("🔍 Fetching NFT Portfolio...");
 
      const contract = new web3.eth.Contract(NFTABI, NFTContarct);
      const Datacontract = new web3.eth.Contract(NFTDataContractABI, NFTDataContract);
      const result = await Datacontract.methods.getUserNFTPortfolio(address).call();

      const ownedIds = result[0] || [];
      const ownedStatuses = result[1] || [];
      const ownedPrices = result[2] || [];
      const ownedImages = result[3] || [];

      const soldIds = result[4] || [];
      const soldPrices = result[5] || [];
      const soldTimestamps = result[6] || [];
      const soldStatuses = result[7] || [];

        // 🚀 FAST PARALLEL CALLS
      const ownedInfos = await Promise.all(
        ownedIds.map((id) =>
          contract.methods.nftInfo(id).call().catch(() => null)
        )
      );

      const soldInfos = await Promise.all(
        soldIds.map((id) =>
          contract.methods.nftInfo(id).call().catch(() => null)
        )
      );

      const soldOwners = await Promise.all(
        soldIds.map((id) =>
          contract.methods.ownerOf(id).call().catch(() => "")
        )
      );

      let tempList = [];

      // ---------- OWNED NFTs ----------
      for (let i = 0; i < ownedIds.length; i++) {
        const st = ownedStatuses[i].toString();

        let status = "Unknown";
        if (st === "0") status = "Hold";
        else if (st === "1") status = "OnSale";
        else if (st === "2") status = "Burned";
        else if (st === "3") status = "Sold";
        const currentPrice = Number(Web3.utils.fromWei(ownedPrices[i].toString(), "ether"));

        // ------------------------
        // 🔹 FETCH onSaleTimeStamp FROM NFT CONTRACT
        // ------------------------
        let onSaleTimeStamp = 0;
        try {
          const nftDetails = await contract.methods
            .nftInfo(ownedIds[i])
            .call();
          onSaleTimeStamp = nftDetails.onSaleTimeStamp;
        } catch {}
      
        // ------------------------
        // 🔹 CHECK SALE AVAILABILITY
        // ------------------------
        // sale message + timer sirf OnSale ke liye
        const saleMessage =
          status === "OnSale" ? getSaleStatus(onSaleTimeStamp) : "";
        
        const remainingTime =
          status === "OnSale" ? getRemainingTime(onSaleTimeStamp) : "";


        // ------------------------
        // CHANGE: calculate paidPrice like contract for ALL NFTs
        // ------------------------
        const feePercent = 5; // same as your contract
        const originalPrice = (currentPrice * 100) / (100 + feePercent);
        const paidPrice = originalPrice; // this is what seller would receive

        tempList.push({
          tokenId: ownedIds[i].toString(),
          price: Web3.utils.fromWei(ownedPrices[i].toString(), "ether"),
          paidPrice,
          status,
          saleMessage, 
          remainingTime,    
          timestamp: "-",
          counterparty: address,
          image: ownedImages[i],
        });
      }

      // ---------- SOLD NFTs ----------
     // SOLD
      for (let i = 0; i < soldIds.length; i++) {
        const statusMap = ["Hold", "OnSale", "Burned", "Sold"];
        const status = statusMap[soldStatuses[i]] || "Unknown";

        const nftInfo = soldInfos[i];
        const nftActualPrice = nftInfo?.priceUSDT || soldPrices[i];

        const sellPrice = Number(
          Web3.utils.fromWei(nftActualPrice.toString(), "ether")
        );

        const paidPrice = (sellPrice * 100) / 110;

        tempList.push({
          tokenId: soldIds[i].toString(),
          price: Web3.utils.fromWei(nftActualPrice.toString(), "ether"),
          paidPrice,
          status,
          timestamp: new Date(
            Number(soldTimestamps[i]) * 1000
          ).toLocaleString(),
          counterparty:
            soldOwners[i] ||
            "0x0000000000000000000000000000000000000000",
          image: nftInfo?.imageURI || "",
        });
      }

      const order = { Hold: 1, OnSale: 2, Sold: 3, Burned: 4 };
      tempList.sort((a, b) => order[a.status] - order[b.status]);

      setNftList(tempList);
      setCurrentPage(1);
    } catch (error) {
      console.error("❌ Error fetching portfolio:", error);
    } finally {
      setIsLoading(false);
    }
  };

  
  // SHOW LOADER WHILE FETCHING
  if (isLoading) return <Loader />;
  const safeList = Array.isArray(nftList) ? nftList : [];

  // ✅ PAGINATION LOGIC
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = nftList.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(nftList.length / recordsPerPage);


  return (
    <div className="buyshheikh-page">
     

     <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning">My NFT   </span> 
          <span className="fw-lighter">Portfolio</span>
        </div>  
         </h4>
      {/* Tabs */}

      <div className="filter-left">
        {["All NFTs", "NFT Activity", "TradeHistory"].map((tab) => (
          <a
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        ))}
      </div>
      <div className="enter-btn">
        <div>
          <span className="text-warning">Burn Own </span> 
          <span className="fw-lighter">NFT</span>
        </div>  
               <input
          type="number"
          className="form-control"
          placeholder="Enter NFT ID..."
          value={tokenId}
          onChange={(e) => setTokenId(e.target.value)}
        />
        <button
        className="new_joining_btn"
        disabled={loading}
        onClick={handleBurnNFT}
      >
        {loading ? "Burning..." : "Burn"}
      </button>

      {msg && (
        <div
          style={{
            marginTop: "8px",
            fontSize: "13px",
            color: msg.includes("✅") ? "green" : "red",
          }}
        >
          {msg}
        </div>
      )}
      </div>
      <div className="row mt-3">
        {currentRecords.length > 0 ? (
          currentRecords.map((item, index) => (
            <div className="col-md-6 col-lg-3 mb-4" key={index}>
              <div className="NFT-card">
                <div className="NFT-card-img">
                  <img
                    // src={item.image || "/placeholder.png"}
                      src={item.image ? `${item.image}?v=1` : "/placeholder.png"}
                    alt="NFT"
                    loading="lazy"
                    style={{ width: "100%", borderRadius: "10px" }}
                  />
                </div>

                <div className="NFT-card-body">

                  <div className="appreciatedprice subtitle-price">Appreciated Price  USDT {formatBalance(item.price)}</div>

                   {item.status !== "Sold" && (
                   <div className="div-buy">
    <div className="btnpurchanse">
      Purchased Price{" "}
      <span className="spanvalue">
        USDT {formatBalance(item.paidPrice)}
      </span>
    </div>

   

     <div className="NetProfit">
      Net Profit USDT{" "}
      <span className="spanvalue">
        USDT{" "}
        {(() => {
          const profit = Number(item.price) - Number(item.paidPrice);
          const netProfit = profit > 0 ? (profit * 40) / 100 : 0;
          return formatBalance(netProfit);
        })()}
      </span>
      {/* <span style={{ marginLeft: "6px", opacity: 0.7 }}>
        (35%)
      </span> */}
    </div>
  </div>
       )}     
              <div className="blockchain-row">
                    <span className="blockchain-span">
                      <img
                        src="/static/media/bnb.87f8862848ad87fc1596e49a7def25f7.svg"
                        width="22"
                        alt=""
                      />
                    </span>

                    <div
                      className="badge"
                      style={{
                        background:
                          item.status === "OnSale"
                            ? "rgb(22, 199, 132)"
                            : item.status === "Hold"
                              ? "#888"
                              : item.status === "Sold"
                                ? "#d9534f"
                                : item.status === "Burned"
                                  ? "#ff9800"
                                  : "#444",
                      }}
                    >
                      {item.status}



                    </div>
                  </div>

                  <div className="subtitle-price">USDT {formatBalance(item.price)}</div>

                  <div className="Owner-row">
                    <div className="subtitle-new">
                      NFT <b className="text-warning">#{item.tokenId}</b>
                    </div>

                    {/* <div className="footer-new">
                      <span>
                        Wallet:{" "}
                        <b className="text-warning">{maskAddress(item.counterparty)}</b>
                      </span>

                      <div className="ref-copy-box" style={{ marginLeft: "8px" }}>
                        <button className="copy-btn" onClick={() => handleCopy(item.counterparty, index)}>
                          {copiedIndex === index ? <FaCheck className="copy-icon copied" /> : <FaCopy className="copy-icon" />}
                        </button>
                      </div>
                    </div> */}
                  </div>

{/* 🔹 SALE STATUS + TIMER — ONLY WHEN ONSALE */}
{item.status === "OnSale" && (
  <div style={{ marginTop: "6px", fontSize: "12px" }}>
    
    {/* STATUS */}
    <div
      style={{
        fontWeight: "600",
        color:
          item.saleMessage === "Listed for Market"
            ? "rgb(22, 199, 132)"
            : "#ff9800",
      }}
    >
      {item.saleMessage}
    </div>

    {/* TIMER — sirf jab time baaki ho */}
    {/* {item.remainingTime && item.saleMessage === "Not available for sale" && (
      <div style={{ fontSize: "11px", color: "#aaa" }}>
        ⏳ Available in: {item.remainingTime}
      </div>
    )} */}
  </div>
)}



                  {/* {Number(item.paidPrice) >= 10 && (
                    <div className="mt-2" style={{ fontSize: "12px", opacity: 0.7 }}>
                      Buy Rate {formatBalance(item.paidPrice)} USDT
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <img src={Nodata} alt="" />
          </div>
        )}
      </div>
       {/* ✅ PAGINATION UI (ADDED ONLY) */}
      {totalPages > 1 && (
        <div className="pagination-div">
          <ul className="pagination mb-0">
            {[...Array(totalPages)].map((_, idx) => (
              <li
                key={idx}
                className={`page-item ${
                  currentPage === idx + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(idx + 1)}
                >
                  {idx + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

    </div>
  );
};

export default MyNFTDetails;
